import React from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/Logo PNG.webp";

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand p-0">
            <img src={img1} alt="Skill Workers logo" className="w-100" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/" className="nav-link active black-underline">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/AboutUs" className="nav-link black-underline">
                  About US
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link black-underline" to="/OurServices">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/ContactUs" className="nav-link black-underline">
                  Contact US
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/Job" className="nav-link black-underline">
                  Job Search
                </Link>
              </li>
            </ul>
            <a href="https://skillworkers.co.uk/candidate/" className="button">
              <button type="button" className="btn btn-primary signup neu-morphism w-100">
                Apply now
              </button>
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
